import { take, put, call, fork, cancel, all, takeEvery, debounce } from 'redux-saga/effects';
import { userActions } from '..';
import { storageServices, userApiServices } from '../../services';

export function* loginByPhone(payload) {
  //   try {
  //     yield call(API.loginByPhoneNumber, loginPayload);
  //     const pinPayload = yield take('LOGIN_PIN_REQUEST');
  //     yield call(API.phonePin, pinPayload);
  //     yield put({ type: 'LOGIN_SUCCESS', token });
  //     yield call(Api.storeItem, { token });
  //   } catch (error) {
  //     yield put({ type: 'LOGIN_ERROR', error });
  //   } finally {
  //     if (yield cancelled()) {
  //       // ... put special cancellation handling code here
  //     }
  //   }
}

// EXAMPLE
// function* authorize(credentialsOrToken) {
//   const { response } = yield race({
//     response: call(authService, credentialsOrToken),
//     signout: take('SIGN_OUT')
//   });

//   // server responded (with Success) before user signed out
//   if (response && response.token) {
//     yield call(setAuthToken, response.token); // save to local storage
//     yield put(authSuccess, response.token);
//     return response.token;
//   }
//   // user signed out before server response OR server responded first but with error
//   else {
//     yield call(signout, response ? response.error : 'User signed out');
//     return null;
//   }
// }
// function* signout(error) {
//   yield call(removeAuthToken); // remove the token from localStorage
//   yield put(actions.signout(error)); // notify th store
// }
// function* authFlow() {
//   let token = yield call(getAuthToken); // retreive from local storage
//   token.expires_in = 0;

//   while (true) {
//     if (!token) {
//       let { credentials } = yield take('SIGN_IN');
//       token = yield call(authorize, credentials);
//     }
//     // authorization failed, wait the next signing
//     if (!token) continue;

//     let userSignedOut;
//     while (!userSignedOut) {
//       const { expired } = yield race({
//         expired: call(delay, token.expires_in),
//         signout: take('SIGN_OUT')
//       });

//       // token expired first
//       if (expired) {
//         token = yield call(authorize, token);
//         // authorization failed, either by the server or the user signout
//         if (!token) {
//           userSignedOut = true; // breaks the loop
//           yield call(signout);
//         }
//       }
//       // user signed out before token expiration
//       else {
//         userSignedOut = true; // breaks the loop
//         yield call(signout);
//       }
//     }
//   }
// }
export function* loginFlow() {
  while (true) {
    const loginPayload = yield take('LOGIN_REQUEST');

    // const loginTask = yield fork(loginByPhone, loginPayload);
    // const action = yield take(['LOGOUT', 'LOGIN_ERROR']);
    // if (action.type === 'LOGOUT') { yield cancel(loginTask); };
    // yield call(Api.clearItem, 'token');
  }
}

function* setUserName({ payload }: ReturnType<typeof userActions.setName>) {
  try {
    yield call(userApiServices.setName, { customerName: payload.name });
  } catch (error) {
    // 🤔 what to do... need more robust solution
  }
}

function* watchUserNameChange() {
  yield debounce(1000, 'SET_CUSTOMER_NAME', setUserName);
  // TODO should be
  // yield debounce(1000, userActions.setName, setUserName);
}

export function* watchLogout() {
  while (true) {
    yield take(userActions.logoutSuccessBridge);

    storageServices.session.clear();
  }
}

export function* userSaga() {
  yield all([fork(watchLogout), fork(watchUserNameChange)]);
}
